//react
import React, { useState, useEffect } from 'react';
import { BallBeat } from 'react-pure-loaders';

//httpClient
import ChartsClient from './../../httpClient/Charts'; 

//components
import InputList from './components/InputList'; 
import MultiSelect from './components/MultiSelect'; 
import ImageUploaderComponent from './components/ImageUploader';
import DatePickerComponent from './components/DatePicker';

//styling
import './ChartQuestions.css';

//Images
import logo from './../../assets/gmr_logo_light.png';
import gmr_avatar from './../../assets/gmr_avatar.png';
import user_avatar from './../../assets/user_avatar.jpeg';

const ChartQuestions = (props) =>  {
  const {formKey, currentFormQuestions, submitFormAnswers} = props; //
  const [formName, setFormName] = useState('');
  const [formDescription, setFormDescription] = useState('');
  const [formQuestions, setFormQuestions] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');  
  const [errorMessage, setErrorMessage] = useState('');
  const [inlineErrorMessage, setInlineErrorMessage] = useState('');  
  const [originalformQuestions, setOriginalFormQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [questionAnswerOptions, setQuestionAnswerOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [employeeInformation, setEmployeeInformation] = useState({formKey: '', firstName: '', lastName: '', city: '', state: '', zipcode: '', dob: '', employeePhone: '', emailAddress: '', supervisorID: '', supervisorEmail: '', supervisorsFullName: '', lookupSource: '', BUName: '', BUCode: '', BUCity: '', BUState: '', BUZipcode: '', submittedBy: 'Self', notes: ''});
  const [displaySubmitButton, setDisplaySubmitButton] = useState(false);
  const [displayContactInformation, setDisplayContactInformation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [messageLoading, setMessageLoading] = useState(false);

  //on component mount
  useEffect(() => {
      if(currentFormQuestions) {
        let formName = currentFormQuestions.formName;
        let formDescription = currentFormQuestions.formDescription;
        let formQuestions = currentFormQuestions.formQuestions;
        setFormName(formName);
        setFormDescription(formDescription);
        setFormQuestions(formQuestions);
        setOriginalFormQuestions(formQuestions);
        setCurrentQuestion(formQuestions[0]);
      }
  },[currentFormQuestions]);


  useEffect(() => {
    if(currentQuestion && (currentQuestion.inputType === "List" || currentQuestion.inputType === "MultiSelect")) {
      var inputOptions = JSON.parse(currentQuestion.inputOptions);
      setQuestionAnswerOptions(inputOptions);
    } else {
      setQuestionAnswerOptions([]);
    }

  },[currentQuestion]);


  //SELECTED INPUT ACTIONS START
  const onButtonOptionClicked = (e) => {
    var { value } = e.target;

    if(value.length === 0){
      value = inputValue;
    }

    processFormAnswerInput(value);
  }

  const onCustomQuestionAnswerClicked = (value) => {
    
    if(currentQuestion.questionKey === "ConfirmEmployeeID") {
      //if identity confirmed, move on to next question else restart process
      if(value === "Yes") {
        // updateCurrentQuestion(currentQuestion.orderBy-1);
        setCurrentQuestion(formQuestions[currentQuestion.orderBy-1]);

      } else {
        setFormQuestions(originalformQuestions);
        setCurrentQuestion(originalformQuestions[0]);
      }
    }
  }
 
  //SELECTED INPUT ACTIONS END

  const processFormAnswerInput = (value) => {
    //1. set current question's answer
    let newQuestionsArr = [...formQuestions]; // copying the old questions array
    newQuestionsArr.find(x => x.id === currentQuestion.id).answer = value; //update answer value for current question
    setFormQuestions(newQuestionsArr); 

    if(currentQuestion.endsForm && (currentQuestion.expectedAnswer === value || currentQuestion.expectedAnswer === null)) {
      setCurrentQuestion(null);
      setDisplaySubmitButton(true);
    } else if(currentQuestion.endsForm && currentQuestion.properties !== null && JSON.parse(currentQuestion.properties)[0].operator.toLowerCase() === "pass combination") {
      //  2. special logic for questions that end forms but depending on the answer of the another question (observing question)
      //      - for example if pass combination = ["Yes","No"] then observing question's answer has to be "Yes" and current
      //        question answer has to be "No" for the form to continue else the form ends.
      
      let passCombination = JSON.parse(currentQuestion.properties)[0].value; //end result should be an array e.g ["Yes","No"] 
      let observesQuestionAnswer = newQuestionsArr.find(x => x.questionKey === JSON.parse(currentQuestion.observesQuestionKeys)[0]).answer; //right now only supports observing the answer of one other question

      if(observesQuestionAnswer === passCombination[0] && value === passCombination[1]){
        let nextQuestionIndex = newQuestionsArr.indexOf(currentQuestion)+1;
        setCurrentQuestion(formQuestions[nextQuestionIndex]);
      } else {
        setCurrentQuestion(null);
        setDisplaySubmitButton(true);
      }

    } else {
      if(currentQuestion.questionKey === "EmployeeID") {
        getEmployeeDetails(value);
      } else {

        //3. find all other questions observing current question
        let allQuestionsObservingCurrentyKey = newQuestionsArr.filter(x => x.observesQuestionKeys !== null 
                                                                      && JSON.parse(x.observesQuestionKeys).indexOf(currentQuestion.questionKey) > -1
                                                                      && x.properties !== null
                                                                      && JSON.parse(x.properties)[JSON.parse(x.observesQuestionKeys).indexOf(currentQuestion.questionKey)].operator.toLowerCase() !== "pass combination");


        if(allQuestionsObservingCurrentyKey.length > 0) {
        //    a. loop through those question and see conditional property for the
        //       current question's answer.

        var BreakException = {};

        try {

              allQuestionsObservingCurrentyKey.forEach((question, questionIndex) => {
                let properties = JSON.parse(question.properties);
                //get index of current Qns key in observesQuestionKeys
                let indexOfCurrentQnsKey = JSON.parse(question.observesQuestionKeys).indexOf(currentQuestion.questionKey);
                if((properties[indexOfCurrentQnsKey].operator.toLowerCase() === "equals" && properties[indexOfCurrentQnsKey].value === value) || (properties[indexOfCurrentQnsKey].operator.toLowerCase() === "not null" && value.length > 0)){
                  //   b. if condition met, set current question to that question
                  // Note: There's no built-in ability to break in forEach. To interrupt execution you would have to throw an exception of some sort. 
                  setCurrentQuestion(question);
                  throw BreakException;
                }
              });
            } catch (e) {
              if (e !== BreakException) throw e;
            }
              //move to next question in the form that isn't observing anyquestion.




        } else {
        //3. if no other questions are observing the current question, proceed to the next question 
          //index of next question by order by value
          let nextQuestionIndex = newQuestionsArr.indexOf(currentQuestion)+1;
          setCurrentQuestion(formQuestions[nextQuestionIndex]);
        }
      }
    }
  }

  const onInputTextChange = e => {
    const { name, value } = e.target;
    setEmployeeInformation((employeeInformation)=>{
      return({
        ...employeeInformation,
        [name]: value
      })
    })
  }

  const validateContactInformation = () => {
    if(displayContactInformation) {
         //validate Input Fields
        let emailAddressPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

        if(!emailAddressPattern.test(employeeInformation.emailAddress)){
          setInlineErrorMessage('Please enter a valid Email Address');
          return;
        } else if (employeeInformation.employeePhone.length !== 10) {
          setInlineErrorMessage('Please enter a valid Cell Phone Number');
          return;          
        } else {
          setInlineErrorMessage('');
          setDisplayContactInformation(false);
          submitResultsToApi();         
        }
    }
  }

  //API CALLS START
  const getEmployeeDetails = (employeeID) => {
    setMessageLoading(true);

    ChartsClient.getEmployeeDetails(employeeID)
    .then(data => {

      setEmployeeInformation((employeeInformation)=>{
        return({
          ...employeeInformation,
          firstName: data.FIRST_NAME,
          lastName: data.LAST_NAME,
          city: data.WORK_CITY,
          state: data.WORK_STATE,
          zipcode: data.WORK_ZIP,
          dob: data.DOB,
          employeePhone: data.MOBILE_PH ? data.MOBILE_PH.replace(/\D/g,'') : '',
          emailAddress: data.EMAIL_ADDRESS,
          supervisorID: data.SUPERVISOR_ID,
          supervisorEmail: data.SUPERVISOR_EMAIL_ADDRESS,
          supervisorsFullName: data.SUPERVISOR_NAME,
          lookupSource: data.LOOKUP_SOURCE,
          BUName: data.BUName,
          BUCode: data.BUCode,
          BUCity: data.BUCity,
          BUState: data.BUState,
          BUZipcode: data.BUZipcode
        });
      });

      setMessageLoading(false);

      setCurrentQuestion({
        id: currentQuestion.id,
        questionKey: "ConfirmEmployeeID",
        question: `Are you ${data.FIRST_NAME} ${data.LAST_NAME}?`,
        inputType: "List",
        inputOptions: '["Yes","No"]',
        observesQuestionKeys: null,
        endsForm: 0,
        customQuestion: true,
        orderBy: currentQuestion.orderBy
      });

    })
    .catch(err => {
      setCurrentQuestion({
        id: currentQuestion.id,
        questionKey: "EmployeeID",
        question: `I couldn't find an Employee Record for ${employeeID}. Let's try again. What's your Employee ID`,
        inputType: "Text",
        inputOptions: null,
        observesQuestionKeys: null,
        endsForm: 0,
        customQuestion: true,
        orderBy: currentQuestion.orderBy
      });

      setMessageLoading(false);
    });
  }

  // const submitResultsToApi = () => {
  //   setIsLoading(true);
  //   let payload = {
  //     formKey: formKey,
  //     employeeInformation,
  //     formQuestions
  //   }
  //   ChartsClient.submitForm(payload)
  //   .then(data => {
  //     setIsLoading(false);
  //     setSuccessMessage(data.message ? data.message : "Form Submitted Successfully");
  //   })
  //   .catch(err => {
  //     setIsLoading(false);
  //     setErrorMessage("Something went wrong. Please try again in a few minutes");
  //   });

  // }

  
  const submitResultsToApi = () => {
    // setIsLoading(true);
    let payload = {
      formKey: formKey,
      formQuestions
    }
    submitFormAnswers(payload);
  }
  //API CALLS END

  const refreshPage = () => {
    setSuccessMessage('');
    window.location.reload(false);
  }

  var questions = formQuestions.map((record, key) => {

    if(record.answer && record.answer.length > 0) { 
      return <div key={record.id}>
        <section className="chat-container">
          <div className="bubble-avatar-left">
            <img src={gmr_avatar} alt="Avatar" className="avatar" />
          </div>
          <div className="bubble-message-left">
            <div className="message">
              {record.question}
            </div>
          </div>
        </section>

        <section className="chat-container">
          <div className="bubble-avatar-right">
            <img src={user_avatar} alt="Avatar" className="avatar" />
          </div>
          <div className="bubble-message-right">
          { record.inputType === "Image" ?
            <div className="mine-plain messages">
              <img src={record.answer} width="200" />
            </div>
          :  
            <div className="mine messages">
              <div className="message">
                { record.answer}
              </div>
            </div>
          }
          </div>  
        </section>
      </div>
    } 
  });

  return (
    <section className="hero main-app">
      <div className="page-main">
        <div>
          <div className={`modal ${successMessage.length > 0 ? "is-active" : ""}`}>
              <div className="modal-background"></div>
              <div className="modal-card">
                <header className="modal-card-head">
                  <p className="modal-card-title">Form Submission Result</p>
                  <button className="delete" aria-label="close" onClick={()=>refreshPage()} />
                </header>
                <section className="modal-card-body">

                  <article className="message is-success">
                    <div className="message-body">
                      <hr />
                      <strong style={{ whiteSpace: 'pre-line' }}>
                          {successMessage.split("\n").map((text,key) => {
                              return <div key={key}>
                                    {text} 
                                    <br />
                              </div>;
                          })}
                      </strong>
                    </div>
                  </article>

                </section>
                <footer className="modal-card-foot">
                  <button className="button" onClick={()=>refreshPage()}>Close</button>
                </footer>
              </div>
            </div>


          <div className="columns is-centered">
            <div className="column">
            
            {/*         
              <div className="is-link is-white has-text-centered">
                <img src={logo} className="App-logo" alt="logo" />
                <h2 className="title has-text-white">
                  {formName}
                </h2>
                <span>{formDescription}</span>
              </div> */}

              <br />

              <div className="box">
                <div className="chat">
                  {questions}

                  { currentQuestion && <div>

                    <section className="chat-container">
                      <div className="bubble-avatar-left">
                        <img src={gmr_avatar} alt="Avatar" className="avatar" />
                      </div>
                      <div className="bubble-message-left">
                        <div className="message">
                          {messageLoading ? <BallBeat color={'#076FB4'} loading={true} /> : <div>{currentQuestion && currentQuestion.question}</div> }
                        </div>
                      </div>
                    </section>

                    <hr />
  
                      { 
                          {
                            'Text': <div className="form-inline">
                                <input type="text" placeholder="Enter Value" name="inputValue" value={inputValue} onChange={(e)=>setInputValue(e.target.value)} />
                                <button className="answerOptions" onClick={(e)=>onButtonOptionClicked(e)}>Save</button>
                            </div>,
                            'MultiLineText': <div className="form-inline">
                                <textarea type="text" rows="3" cols="60" placeholder="Enter Value" name="inputValue" value={inputValue} onChange={(e)=>setInputValue(e.target.value)} />
                                <button className="answerOptions" onClick={(e)=>onButtonOptionClicked(e)}>Save</button>
                            </div>,
                            'MultiSelect': <MultiSelect 
                                              currentQuestion={currentQuestion}
                                              onSelectedOptionsSubmitted={processFormAnswerInput}
                                              questionAnswerOptions={questionAnswerOptions}
                                            />, 
                            'List': <InputList 
                                      currentQuestion={currentQuestion}
                                      onButtonOptionClicked={processFormAnswerInput}
                                      onCustomQuestionAnswerClicked={onCustomQuestionAnswerClicked}
                                      questionAnswerOptions={questionAnswerOptions}
                                    />,      
                            'Date':  <DatePickerComponent onDateSelected={processFormAnswerInput}  />,
                            'Image': <ImageUploaderComponent onImageUploaded={processFormAnswerInput}  />
                          }[currentQuestion.inputType]
                      }
                  </div> }

                </div>

              </div>
              <button disabled={!displaySubmitButton || isLoading} onClick={()=>submitResultsToApi()} className={`button is-info is-hovered is-medium is-fullwidth ${isLoading ? "is-loading" : ""}`}>Submit Form</button> 
              
              { errorMessage.length > 0 && <article className="message is-danger is-half">
                  <div className="message-header">
                    <p>Error</p>
                    <button className="delete" aria-label="delete" onClick={()=>setErrorMessage('')} />
                  </div>
                  <div className="message-body">
                    <strong>{errorMessage}</strong>
                  </div>
                </article> }  


      <div className={`modal ${displayContactInformation ? "is-active" : ""}`}>
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Confirm Contact Information</p>
            <button className="delete" aria-label="close" onClick={()=>setDisplayContactInformation(false)} />
          </header>
          <section className="modal-card-body">

          {inlineErrorMessage && <div className="columns is-centered">
            <div className="column">
              <article className="message is-danger">
                <div className="message-header">
                  <p>Validation Error</p>
                  <button className="delete" aria-label="delete" onClick={()=>setInlineErrorMessage('')} />
                </div>
                <div className="message-body">
                  <strong>{inlineErrorMessage}</strong>
                </div>
              </article>
            </div>
          </div> }  

            <article className="message is-info">
              <div className="message-body">
                <div className="field">
                  <label className="label">If this is not your current contact information, please update it below:</label>
                  <br />
                  <div className="field">
                    <label className="label">Email Address*</label>
                    <div className="control">
                    <input 
                      className="input" 
                      type="email" 
                      placeholder="alexsmith@email.com"
                      name="emailAddress"
                      value={employeeInformation.emailAddress}
                      onChange={onInputTextChange} />
                    </div>
                  </div>
                  <hr />
                  <div className="field">
                    <label className="label">Cell Phone Number*</label>
                    <div className="control">
                      <input 
                        className="input" 
                        type="number" 
                        placeholder=""
                        name="employeePhone"
                        value={employeeInformation.employeePhone}
                        onChange={onInputTextChange} />
                    </div>
                    <p className="help">Enter 10 digits with no dashes</p>
                  </div>
                  <hr />
                  <div className="field">
                    <label className="label">Submitted By*</label>
                    <div className="control">

                      <span className="select is-medium">
                        <select name="submittedBy" 
                        value={employeeInformation.submittedBy} 
                        onChange={onInputTextChange}>
                          <option value="Self">Self</option>
                          <option value="Navigator">Navigator</option>
                        </select>
                      </span>

                    </div>
                    <p className="help">The person submitting this form</p>
                  </div>
                  { employeeInformation.submittedBy === "Navigator" && <div className="field">
                    <label className="label">Comments</label>
                    <div className="control">
                    <textarea 
                      className="textarea"
                      type="text" 
                      placeholder="Additional Comments"
                      name="notes"
                      rows="4"
                      value={employeeInformation.notes}
                      onChange={onInputTextChange} />
                    </div>
                  </div> }                    
                </div>
              </div>
            </article>


          </section>
          <footer className="modal-card-foot">
            <button className={"button is-info is-hovered is-medium is-fullwidth is-success"} 
              disabled={employeeInformation.emailAddress.length === 0 || 
              employeeInformation.employeePhone.length === 0} 
              onClick={validateContactInformation}
            >Confirmed</button>
          </footer>
        </div>
      </div>



           
            </div>
           </div>
        </div>
      </div>
    </section>
   );
}

export default ChartQuestions;
